// extracted by mini-css-extract-plugin
export default {"root":"Pair_root__lA8hL"};